/* eslint-disable @typescript-eslint/no-require-imports */

// Clone the built-in swagger shim
Object.assign(exports, require("@nestjs/swagger/dist/extra/swagger-shim"))

// Delegate the mapping decorators to mapped-types, which works in the browser
const mappedTypes = require("@nestjs/mapped-types")
exports.IntersectionType = mappedTypes.IntersectionType
exports.OmitType = mappedTypes.OmitType
exports.PartialType = mappedTypes.PartialType
exports.PickType = mappedTypes.PickType
